import BaseModel from './BaseModel';
import moment from 'moment';
import i18n from '../locales/i18n';

/** Class representing a classroom. */
class Classroom extends BaseModel {
    getSchedulingText() {
        const [startH, startM] = this.start_time.split(':').map(n => Number(n));
        const [endH, endM]     = this.end_time.split(':').map(n => Number(n));

        const start = moment()
            .day(this.week_day)
            .hours(startH)
            .minutes(startM)
            .seconds(0);

        const end = moment()
            .day(this.week_day)
            .hours(endH)
            .minutes(endM)
            .seconds(0);

        return i18n.t('groups.on_week_day_from_time_to_time', {
            day: start.format('dddd'),
            start: start.format('LT'),
            end: end.format('LT')
        });
    }

    getSchedulingDayText() {
        const start = moment().day(this.week_day);

        return start.format('dddd').replace(/^./, str => str.toUpperCase());
    }

    getSchedulingTimeText() {
        const [startH, startM] = this.start_time.split(':').map(n => Number(n));
        const [endH, endM]     = this.end_time.split(':').map(n => Number(n));

        const start = moment()
            .day(this.week_day)
            .hours(startH)
            .minutes(startM)
            .seconds(0);

        const end = moment()
            .day(this.week_day)
            .hours(endH)
            .minutes(endM)
            .seconds(0);

        return start.format('LT') + ' - ' + end.format('LT');
    }
}

export default Classroom;
